<template>
  <div class="group-margin">
    <div
    class="group-margin__value-block"
    @click="openNewValueMenu">
      <span class="group-margin__value-text">{{ getMarginText }}</span>
    </div>
    <transition name="fade">
      <div
      v-if="isOpen"
      v-click-outside="() => { isOpen = false }"
      class="group-margin__new-value-block">
        <div class="group-margin__new-value-container">
          <span class="group-margin__value-text">
            Новая наценка:
          </span>
          <DataInput
          v-model="newMargin"
          class="group-margin__new-value-input" />
          <DataButton
          icon="done"
          width="40"
          height="40"
          @handler="setMargin" />
        </div>
        <span
        v-if="newValueError && isInvalidNewValue"
        class="group-margin__value-text group-margin__value-text_invalid">Укажите наценку от 1 до 100</span>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'GroupMargin',
  props: {
    group: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    isOpen: false,
    newMargin: '',
    newValueError: false,
  }),
  methods: {
    openNewValueMenu() {
      if (!this.isAdmin) return;
      if (this.isOpen) {
        this.isOpen = false;
        return;
      }
      this.newMargin = this.getMargin;
      this.isOpen = true;
    },
    setMargin() {
      if (this.isInvalidNewValue) {
        this.newValueError = true;
        return;
      }
      this.newValueError = false;
      const params = {
        compilationId: String(this.getCompilationInfo.id),
        positions: [
          {
            groupIdentity: {
              id: this.group.id,
              social: this.group.social,
            },
            value: this.newMargin,
            type: 'margin',
          },
        ],
        type: 'margin',
      };
      this.$store.dispatch('compilations/changeCollectionPrice', params)
        .then(() => {
          this.$store.dispatch('app/setSnackBar', { text: 'Наценка изменена' });
        })
        .finally(() => {
          this.isOpen = false;
        });
    },
  },
  computed: {
    getMargin() {
      try {
        const groupTradeoffer = this.group.products.find((item) => item.tradeOffersChain.currentTradeOffer.calcType === 2);
        const groupComission = groupTradeoffer ? groupTradeoffer.tradeOffersChain.currentTradeOffer : null;
        if (groupComission && groupComission.calcValue) {
          return groupComission.calcValue;
        }
        return '';
      } catch {
        return '?';
      }
    },
    getMarginText() {
      return this.getMargin ? `${this.getMargin}%` : '-';
    },
    isAdmin() {
      return this.$store.getters['user/getIsAdmin'];
    },
    isInvalidNewValue() {
      return !this.newMargin || Number(this.newMargin) > 100 || Number(this.newMargin) < 1;
    },
    getCompilationInfo() {
      return this.$store.getters['compilations/getCurrentCompilationInfo'];
    },
  },
};
</script>

<style lang="scss" scoped>
.group-margin {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  .group-margin__value-block {
    padding: 10px 20px;
    background: rgba($primary-gray, 0.05);
    border-radius: 10px;
    min-width: 70px;
    cursor: pointer;
    margin-right: 10px;
  }

  .group-margin__value-text {
    color: $primary-gray;
    font-size: 14px;
    white-space: nowrap;
    &_invalid {
      color: $primary-red;
      margin-top: 5px;
    }
  }

  .group-margin__new-value-block {
    position: absolute;
    top: 35px;
    left: -12px;
    background-color: white;
    width: 290px;
    box-shadow: 0px 0px 10px 1px rgb(34 60 80 / 10%);
    border-radius: 12px;
    padding: 10px 20px;
    z-index: 2;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
  }

  .group-margin__new-value-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    @include between-elements {
      margin-right: 10px;
    }
  }

  .group-margin__new-value-input {
    width: 75px;
  }
}
</style>
